import { useSnackbar } from 'notistack';
import React from 'react';
import { useCustomerData } from '../customerData';
import { CustomerCarService } from 'src/services/customer/customerCarService';
import { useStyles } from 'src/theme/vemigoCustomStyles/VemigoCustomStyles';
import { StatusSwitch } from 'src/components/VemigoGrid/VemigoStarusFeild';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  MenuItem,
  Select,
  TextField,
  Typography
} from '@mui/material';
import { useCustomerBookingCart } from '../selectedCustomerData';

export const EditCustomersCar = (props) => {
  const { handleGetCustomerCarById } = useCustomerBookingCart();
  const { rowData, data, open, handleClose } = props;
  const dataModel = {
    id: 0,
    carId: 0,
    carNickName: '',
    registrationNumber: 0,
    passingYear: 0,
    fuelTypeId: 0,
    engineNumber: 0,
    carColor: '',
    chassisNumber: 0,
    customerId: 0,
    updatedBy: 0,
    isActive: true
  };

  const [newData, setNewData] = React.useState(dataModel);
  const { enqueueSnackbar } = useSnackbar();
  const { customerfuelType, allCars } = useCustomerData();
  const [selectedFuelTypeList, setSelectedFuelTypeList] = React.useState([]);
  const [selectedFuelTypeId, setSelectedFuelTypeId] = React.useState('');
  const [selectedCarList, setSelectedCarList] = React.useState([]);
  const [selectedCarId, setSelectedCarId] = React.useState('');
  const [isAddButtonDisabled, setIsAddButtonDisabled] = React.useState(true);

  const car = data.find((item) => item.customerCarId === rowData.id || item.customerCarId === rowData.customerCarId);

  const handleAddClose = () => {
    handleClose();
    setNewData(dataModel);
    setSelectedCarList(allCars);
    setSelectedCarId('');
    setSelectedFuelTypeId('');
    setIsAddButtonDisabled(true);
  };

  React.useEffect(() => {
    const fetchData = async () => {
      try {
        setSelectedFuelTypeList(customerfuelType);
        setSelectedCarList(allCars);
      } catch (error) {
        console.error('Error fetching data from the API:', error);
      }
    };
    const customerCarId = rowData.id || rowData.customerCarId;
    setNewData({
      id: customerCarId,
      carId: car?.carId,
      carNickName: car?.carNickName,
      registrationNumber: car?.registrationNumber,
      passingYear: car?.passingYear,
      fuelTypeId: car?.fuelTypeId,
      engineNumber: car?.engineNumber,
      carColor: car?.carColor,
      chassisNumber: car?.chassisNumber,
      customerId: car?.customerId,
      isActive: car?.isActive,
      updatedBy: car?.updatedBy
    });
    setSelectedFuelTypeId(car?.fuelTypeId);
    setSelectedCarId(car?.carId);
    fetchData();
  }, [rowData]);

  const handleDataChange = (fieldName, value) => {
    setNewData({ ...newData, [fieldName]: value });
  };

  const handleAddNewData = async () => {
    if (!newData.carId) {
      enqueueSnackbar('Please fill in all mandatory fields', {
        variant: 'error'
      });
      return;
    }
    const res = await CustomerCarService.editData(newData);
    try {
      handleGetCustomerCarById('Get');
      props.handleEditeData(true, res.data);
      handleClose();

    } catch (error) {
      console.error('Error updating data:', error);
    }
  }

  const getFieldValue = (fieldId) => {
    if (fieldId.includes('.')) {
      const [parent, child] = fieldId.split('.');
      return newData[parent][child] || '';
    }
    return newData[fieldId] || '';
  };

  const allFields = [
    {
      id: 'carId',
      field: 'Select',
      title: 'Search Car*',
      selectedId: selectedCarId,
      dataList: selectedCarList,
      function: setSelectedCarId,
      type: 'text',
      size: 12
    },
    {
      id: 'carNickName',
      field: 'textField',
      title: 'Car Nick Name',
      type: 'text',
      size: 12
    },
    {
      id: 'registrationNumber',
      field: 'textField',
      title: 'Registration Number',
      type: 'text',
      size: 6
    },
    {
      id: 'passingYear',
      field: 'textField',
      title: 'Passing Year',
      type: 'text',
      size: 6
    },
    {
      id: 'fuelTypeId',
      field: 'Select',
      title: 'Fuel Type',
      type: 'text',
      selectedId: selectedFuelTypeId,
      dataList: selectedFuelTypeList,
      function: setSelectedFuelTypeId,
      size: 6
    },
    {
      id: 'engineNumber',
      field: 'textField',
      title: 'Engine Number',
      type: 'text',
      size: 6
    },
    {
      id: 'carColor',
      field: 'textField',
      title: 'Car Color',
      type: 'date',
      size: 6
    },
    {
      id: 'chassisNumber',
      field: 'textField',
      title: 'Chassic Number',
      type: 'date',
      size: 6
    },
    {
      id: 'isActive',
      field: 'status',
      // title: 'Status',
      type: 'text',
      size: 12
    }
  ];



  return (
    <>
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle style={useStyles.dialogTitle}>
          Edit Car
        </DialogTitle>
        <DialogContent style={useStyles.bodyStyle}>
          <Grid container spacing={2} style={useStyles.boxSize}>
            {allFields.map((field) => (
              <Grid item xs={field.size} key={field.id}>
                <Typography style={useStyles.formTitle}>
                  {field.title}
                </Typography>
                {field.field === 'textField' && (
                  <TextField
                    style={useStyles.formControl}
                    margin="dense"
                    id={field.id}
                    type="dateTime"
                    fullWidth
                    value={getFieldValue(field.id) || ''}
                    onChange={(e) => handleDataChange(field.id, e.target.value)}
                    key={`textfield-${field.id}`}
                  />
                )}
                {field.field === 'Select' && (
                  <Select
                    displayEmpty
                    style={useStyles.formControl}
                    fullWidth
                    value={field.selectedId}
                    onChange={(e) => {
                      handleDataChange(field.id, e.target.value);
                      field.function(e.target.value);
                    }}
                  >
                    <MenuItem value="" disabled key={`${field.id}-empty`}>
                      <em>{field.type}</em>
                    </MenuItem>
                    {field.dataList.map((data) => (
                      <MenuItem key={data.id} value={data.id}>
                        {data.name}
                      </MenuItem>
                    ))}
                  </Select>
                )}
                {field.field === 'status' && (
                  <StatusSwitch
                    newData={newData}
                    handleSwitchChange={handleDataChange}
                    field={field.id}
                  />
                )}
              </Grid>
            ))}
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleAddClose} variant="contained">
            Cancel
          </Button>
          <Button
            onClick={handleAddNewData}
            color="primary"
            variant="contained"
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
